<template>
    <div class="activity-item"
        @click="jumpToNext">
        <div class="item-wrapper">
            <!-- 主图 -->
            <div class="big-image">
                <!-- 活动状态角标 -->
                <div class="activity-status-icon">
                    <img class="icon"
                        :src="statusIcon" />
                </div>
                <img class="main"
                    :src="item.bigImageUrl" />
            </div>
            <!-- 文字内容区 -->
            <div class="text-area">
                <div class="top-line">
                    <div class="activity-title">{{ item.activityName }}</div>
                    <div class="activity-guide-status">{{ getActivityGuideTag(item.activityGuideType) }}</div>
                </div>
                <div v-if="item.activityType !== activityType.storeNavigation"
                    class="activity-time">
                    <div class="label">活动时间范围:</div>
                    <div class="value">{{ `${item.activityStartTime || ''} - ${item.activityEndTime || ''}` }}</div>
                </div>
                <!-- 底部按钮区 -->
                <div :class="{'bottom-btn-area': true, 'no-btn': isGuided}">
                    <div v-if="!isGuided"
                        class="to-join-btn">去参与</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { activityGuideType, ActivityStatus, LoginType, ActivityType } from '../../../../commons/commonVariables';
import { jumpActivityGuidePage } from '../../runtime/common-methods/utils';

export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    loginType: {
      type: String,
      default: LoginType.None,
    },
  },
  data() {
    return {
      activityType: ActivityType,
    };
  },
  computed: {
    statusIcon() {
      const status = this.item.status;
      switch (status) {
        case ActivityStatus.notStarted:
          return require('../../../../../static/image/activityCenter/notStart.svg');
        case ActivityStatus.running:
          return require('../../../../../static/image/activityCenter/running.svg');
        default:
          return '';
      }
    },
    // 是否已预约导购
    isGuided() {
      return this.item.activityGuideType === activityGuideType.alreadyBooked;
    },
  },
  methods: {
    jumpToNext() {
      // 1.已预约的微信活动，则跳转小程序的活动预约页面
      if (this.isGuided && this.loginType === LoginType.Wechat) {
        this.jumpGuideListPage();
      } else {
        // 2.否则，跳转活动详情页
        this.$emit('jump', this.item);
      }
    },
    getActivityGuideTag(status) {
      switch (status) {
        case activityGuideType.toJoin:
          return '';
        case activityGuideType.noReservation:
          return '未预约';
        case activityGuideType.alreadyBooked:
          return '已预约';
        default:
          return '';
      }
    },
    // 跳转活动预约列表页
    jumpGuideListPage() {
      jumpActivityGuidePage(this.loginType);
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-item {
  width: 100vw;
  margin-bottom: 10px;
  .item-wrapper {
    width: 92vw;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 6px;
    overflow: hidden;
    .big-image {
      width: 92vw;
      height: 46vw;
      position: relative;
      .activity-status-icon {
        position: absolute;
        left: 0;
        top: 0;
        width: 13.33vw;
        height: 13.33vw;
        .icon {
          width: 100%;
          height: 100%;
        }
      }
      .main {
        width: 100%;
        height: 100%;
      }
    }
  }

  .text-area {
    margin: 0 12px;
    font-family: HONORSansBrand-Regular;
    .top-line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 5px;

      letter-spacing: 0;
      padding: 6px 0;
      .activity-title {
        font-size: 18px;
        color: #000000;
        font-weight: 400;
        // 超出两行显示省略号
        display: -webkit-box;
        -webkit-line-clamp: 2; /* 限制在两行 */
        -webkit-box-orient: vertical;
        line-height: 1.2; /* 调整行高 */
        max-height: 3em; /* 设置最大高度，这里假设行高为1.5，所以2行的高度是3em */
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }
      .activity-guide-status {
        font-size: 14px;
        color: #256fff;
        text-align: right;
        line-height: 15px;
        font-weight: 400;
        flex-shrink: 0;
        margin-left: 5px;
      }
    }

    .activity-time {
      font-size: 12px;
      color: #999999;
      letter-spacing: 0;
      line-height: 15px;
      font-weight: 400;
    }

    .bottom-btn-area {
      padding: 15px 0;
      display: flex;
      flex-direction: row-reverse;
      .to-join-btn {
        width: 20.9vw;
        height: 7.46vw;
        min-width: 70px;
        min-height: 25px;
        background: #256fff;
        border-radius: 40px;
        text-align: center;
        line-height: 7.46vw;
        color: #fff;
      }
    }
    .no-btn {
      padding: 12px 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/activityCenter/components/activityItem.vue